(() => {
  'use strict';
  const requests = new Map();
  async function getOptions(path) {
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin) throw new Error('Unexpected collection origin');
    url.searchParams.set('section_id', 'aonsk-available-options');
    url.searchParams.set('filter.v.availability', '1');
    const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    const key = url.toString();
    if (!requests.has(key)) {
      requests.set(key, fetch(key, { credentials: 'same-origin', signal: AbortSignal.timeout(10000) })
        .then(async (response) => {
          if (!response.ok) throw new Error('Collection unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = doc.querySelector('[data-available-options-result]');
          if (!result) throw new Error('Options not returned');
          return result;
        }).catch((error) => { requests.delete(key); throw error; }));
    }
    return requests.get(key);
  }
  if (!customElements.get('aonsk-available-options')) {
    customElements.define('aonsk-available-options', class extends HTMLElement {
      connectedCallback() {
        if (this.loaded) return;
        this.loaded = true;
        this.load();
      }
      async load() {
        const note = this.querySelector('[data-options-note]');
        const items = this.querySelector('[data-options-items]');
        const browse = this.querySelector('.aonsk-available__browse');
        const heading = this.querySelector('.aonsk-available__title');
        try {
          let result = await getOptions(this.dataset.source);
          let cards = result.querySelectorAll('.aonsk-available__item');
          if (!cards.length && this.dataset.parent) {
            result = await getOptions(this.dataset.parent);
            cards = result.querySelectorAll('.aonsk-available__item');
            if (cards.length) {
              heading.textContent = this.dataset.parentTitle;
              note.textContent = this.querySelector('[data-options-parent]').content.textContent;
              browse.href = this.dataset.parent;
              browse.textContent = this.dataset.parentTitle;
            }
          }
          if (!this.isConnected) return;
          if (cards.length) {
            items.replaceChildren(...Array.from(cards, (card) => card.cloneNode(true)));
            if (heading.textContent === this.dataset.title) note.hidden = true;
          } else {
            heading.hidden = true;
            note.textContent = this.querySelector('[data-options-empty]').content.textContent;
          }
        } catch (_) {
          note.textContent = this.querySelector('[data-options-failed]').content.textContent;
        }
      }
    });
  }
  document.addEventListener('on:facet-filters:updated', () => {
    const fresh = document.querySelector('#filter-results .aonsk-stock-shortcut');
    document.querySelectorAll('[data-aonsk-stock-top]').forEach((top) => {
      if (fresh) top.replaceChildren(fresh.cloneNode(true));
    });
    const hasFilters = Array.from(new URLSearchParams(window.location.search).keys()).some((key) => key.startsWith('filter.'));
    document.querySelectorAll('[data-aonsk-collection-options]').forEach((block) => { block.hidden = hasFilters; });
  });
})();
